import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ChevronRight } from "lucide-react";

export default function Shows() {
  const [shows, setShows] = useState([]);

  useEffect(() => {
    api.get("/shows").then((r) => setShows(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28" data-testid="shows-page">
      <div className="max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold mb-4">The Network</p>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter">
          All shows. <span className="text-svn-red">One signal.</span>
        </h1>
        <p className="mt-6 text-lg text-neutral-300 font-body">
          Every voice on the network. Sports, food, relationships, growth and
          everything moving the culture forward.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="shows-grid">
        {shows.map((s) => (
          <Link
            to={`/shows/${s.slug}`}
            key={s.id}
            className="group bg-[#0F0F0F] border border-white/5 hover:border-gold/40 transition-all overflow-hidden"
            data-testid={`show-card-${s.slug}`}
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={s.artwork_url}
                alt={s.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-6">
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-gold">
                {s.schedule.join(" • ")}
              </p>
              <h2 className="mt-3 font-display text-3xl font-black tracking-tight">
                {s.title}
              </h2>
              <p className="mt-2 text-neutral-300">{s.tagline}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {s.topics.slice(0, 3).map((t) => (
                  <span key={t} className="text-[10px] uppercase tracking-widest text-neutral-400 border border-white/10 px-2 py-1">
                    {t}
                  </span>
                ))}
              </div>
              <div className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white group-hover:text-gold transition-colors">
                Explore Show <ChevronRight size={14} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
